'use client';
import type React from 'react';
import SvgSymbolWrapper from './SvgSymbolWrapper';
import { ReactComponent as Airplane } from './svgs/airplane.svg?react';
import { ReactComponent as AirplaneWithBackground } from './svgs/airplane-with-background.svg?react';
// not in figma
import { ReactComponent as AlertSign } from './svgs/alert-sign.svg?react';
import { ReactComponent as Link } from './svgs/anchor-link.svg?react';
import { ReactComponent as Android } from './svgs/android.svg?react';
import { ReactComponent as AppearPassword } from './svgs/appear-password.svg?react';
// in figma;
import { ReactComponent as Articles } from './svgs/articles.svg?react';
import { ReactComponent as ArticlesToday } from './svgs/articles-today.svg?react';
import { ReactComponent as AvatarContactWithBackground } from './svgs/avatar-contact.svg?react';
import { ReactComponent as Average } from './svgs/average.svg?react';
import { ReactComponent as BrokenLink } from './svgs/broken-link.svg?react';
import { ReactComponent as Calendar } from './svgs/calendar.svg?react';
import { ReactComponent as CheckDone } from './svgs/check-done.svg?react';
import { ReactComponent as Upload } from './svgs/cloud-upload.svg?react';
import { ReactComponent as DocumentPage } from './svgs/document-page.svg?react';
import { ReactComponent as File } from './svgs/file.svg?react';
import { ReactComponent as Download } from './svgs/file-download.svg?react';
import { ReactComponent as ForwardTime } from './svgs/forward-time.svg?react';
import { ReactComponent as Group } from './svgs/group.svg?react';
import { ReactComponent as HeaderImages } from './svgs/headerimages.svg?react';
import { ReactComponent as Headphones } from './svgs/headphones.svg?react';
import { ReactComponent as HidePassword } from './svgs/hide-password.svg?react';
import { ReactComponent as IPhone } from './svgs/iphone.svg?react';
import { ReactComponent as Laptop } from './svgs/laptop.svg?react';
import { ReactComponent as NewUser } from './svgs/new-user.svg?react';
import { ReactComponent as Newspaper } from './svgs/newspaper.svg?react';
import { ReactComponent as Newsroom } from './svgs/newsroom.svg?react';
import { ReactComponent as NoPublications } from './svgs/no-publications.svg?react';
import { ReactComponent as NoResults } from './svgs/no-result.svg?react';
import { ReactComponent as PerformanceBoard } from './svgs/performance-board.svg?react';
import { ReactComponent as Preview } from './svgs/preview.svg?react';
import { ReactComponent as RelatedContent } from './svgs/relatedcontent.svg?react';
import { ReactComponent as Rocket } from './svgs/rocket.svg?react';
import { ReactComponent as RocketLaunch } from './svgs/rocket-launch.svg?react';
import { ReactComponent as SendingMessage } from './svgs/sending-message.svg?react';
import { ReactComponent as SocialChannels } from './svgs/socialchannels.svg?react';
import { ReactComponent as ThumbsUp } from './svgs/thumbs-up.svg?react';
import { ReactComponent as VideoCam } from './svgs/video-cam.svg?react';
import { ReactComponent as Watch } from './svgs/watch.svg?react';

export type Props = {
  size?: 'small' | 'medium' | 'large';
  variant?: string;
} & React.HTMLAttributes<HTMLElement>;

export type SymbolsType = React.FunctionComponent<Props>;

const wrapSymbol = (Component: React.FunctionComponent<React.SVGProps<SVGSVGElement>>) =>
  function Symbol({ size, ...props }: Props) {
    return (
      <SvgSymbolWrapper $size={size} {...props}>
        <Component />
      </SvgSymbolWrapper>
    );
  };

const Symbols = {
  // in figma
  Airplane: wrapSymbol(Airplane),
  AirplaneWithBackground: wrapSymbol(AirplaneWithBackground),
  Android: wrapSymbol(Android),
  AppearPassword: wrapSymbol(AppearPassword),
  Articles: wrapSymbol(Articles),
  ArticlesToday: wrapSymbol(ArticlesToday),
  AvatarContactWithBackground: wrapSymbol(AvatarContactWithBackground),
  Average: wrapSymbol(Average),
  Calendar: wrapSymbol(Calendar),
  Download: wrapSymbol(Download),
  ForwardTime: wrapSymbol(ForwardTime),
  Group: wrapSymbol(Group),
  HeaderImages: wrapSymbol(HeaderImages),
  IPhone: wrapSymbol(IPhone),
  Laptop: wrapSymbol(Laptop),
  Link: wrapSymbol(Link),
  Newspaper: wrapSymbol(Newspaper),
  Newsroom: wrapSymbol(Newsroom),
  NewUser: wrapSymbol(NewUser),
  NoResults: wrapSymbol(NoResults),
  PerformanceBoard: wrapSymbol(PerformanceBoard),
  Preview: wrapSymbol(Preview),
  RelatedContent: wrapSymbol(RelatedContent),
  SendingMessage: wrapSymbol(SendingMessage),
  SocialChannels: wrapSymbol(SocialChannels),
  Watch: wrapSymbol(Watch),

  // not in figma
  AlertSign: wrapSymbol(AlertSign),
  BrokenLink: wrapSymbol(BrokenLink),
  CheckDone: wrapSymbol(CheckDone),
  DocumentPage: wrapSymbol(DocumentPage),
  File: wrapSymbol(File),
  Headphones: wrapSymbol(Headphones),
  HidePassword: wrapSymbol(HidePassword),
  NoPublications: wrapSymbol(NoPublications),
  Rocket: wrapSymbol(Rocket),
  RocketLaunch: wrapSymbol(RocketLaunch),
  UploadNoWrapper: Upload,
  ThumbsUp: wrapSymbol(ThumbsUp),
  VideoCam: wrapSymbol(VideoCam),
};

export default Symbols as { [key in keyof typeof Symbols]: SymbolsType };
